import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import ChatWidget from '@/components/ChatWidget';

const HousePlanBot = () => {
  return (
    <div className="min-h-screen bg-stone-50">
      <nav className="fixed top-0 left-0 right-0 bg-[#81be00] text-white shadow z-40">
        <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
          <Link to="/" className="inline-flex items-center text-white/95 hover:text-white">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Site
          </Link>
          <div className="font-semibold">Nyinimu Assistant</div>
          <div />
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-4 pt-24 pb-12">
        <h1 className="text-3xl font-bold text-stone-800 mb-2">Nyinimu Chat Assistant</h1>
        <p className="text-stone-600 mb-6">
          Ask about properties, bookings, blogs or how Nyinimu works. I can remember this conversation for
          later.
        </p>

        <ChatWidget variant="page" />
      </div>
    </div>
  );
};

export default HousePlanBot;
